"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OnTurnStarted_EmperorsRegenerationEventHandlerScript = void 0;
const Duration_1 = require("../../core/Duration");
const core_1 = require("../../core/effects/core");
const Registries_1 = require("../../core/state/Registries");
const Target_1 = require("../../core/Target");
let OnTurnStarted_EmperorsRegenerationEventHandlerScript = class OnTurnStarted_EmperorsRegenerationEventHandlerScript {
    run(sequence, container, handler, event) {
        const allyCount = container.selectLivingTargets(event.subject, Target_1.Target.AllAllies).length;
        const regen = handler.args.scriptArgs.baseRegen * allyCount;
        container.applyEffect(sequence, event.subject, event.subject, new core_1.HoTHealingEffectArgs("EmperorsRegeneration", regen, 100), Duration_1.Duration.Instant);
    }
};
OnTurnStarted_EmperorsRegenerationEventHandlerScript = __decorate([
    Registries_1.EventHandlerScripts.register("OnTurnStarted_EmperorsRegeneration")
], OnTurnStarted_EmperorsRegenerationEventHandlerScript);
exports.OnTurnStarted_EmperorsRegenerationEventHandlerScript = OnTurnStarted_EmperorsRegenerationEventHandlerScript;
